export const LEADERS = [
    {
      id: 0,
      name: 'John Donaldson',
      image: '/assets/images/John.png',
      designation: 'Author',
      abbr: 'Author',
      featured: false,
      description: "John Donaldson is an International Master  with 2 Grandmaster norms. He has authored numerous works of chess literature, played in the US Chess Championship twice, captained the US National Team in Olympiads and World Team Championships on 21 different occasions and was the Director of the San Francisco Mechanics' Institute Chess Club for twenty years."
    },
    {
      id: 1,
      name: 'Eric Tangborn',
      image: '/assets/images/Eric.png',
      designation: 'Author',
      abbr: 'Author',
      featured: true,
      description: 'Eric Tangborn is an International Master and also designs this website. Please contact him if you any comments or suggestions.'
    }
  ];
